import { render, staticRenderFns } from "./warehouseTaskChoice.vue?vue&type=template&id=ebd74696&scoped=true"
import script from "./warehouseTaskChoice.vue?vue&type=script&lang=js"
export * from "./warehouseTaskChoice.vue?vue&type=script&lang=js"
import style0 from "./warehouseTaskChoice.vue?vue&type=style&index=0&id=ebd74696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd74696",
  null
  
)

export default component.exports